import { Flame, Sparkles, Heart } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { siteData } from "../data/mock";

const iconMap = {
  flame: Flame,
  sparkles: Sparkles,
  heart: Heart,
};

const iconColors = {
  flame: { bg: "#F0F4ED", color: "#5E8C61" },
  sparkles: { bg: "#F0F4ED", color: "#5E8C61" },
  heart: { bg: "#F0F4ED", color: "#5E8C61" },
};

export const ServicesSection = () => {
  return (
    <section
      id="services"
      aria-labelledby="services-heading"
      className="py-20 lg:py-28"
      style={{ background: "#FFF9F2" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-stone-200 text-sm text-stone-600 mb-6 bg-white">
            Traditional Healing, Modern Results
          </span>
          <h2
            id="services-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#232323] mb-4 tracking-tight"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            Our Services
          </h2>
          <div className="w-12 h-1 bg-[#232323] mx-auto rounded-full" />
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {siteData.services.map((service) => {
            const Icon = iconMap[service.icon];
            const colors = iconColors[service.icon];
            return (
              <Card
                key={service.id}
                className="border border-stone-100 hover:border-stone-200 shadow-sm hover:shadow-lg transition-all duration-300 rounded-2xl overflow-hidden bg-white group"
                data-testid={`service-card-${service.id}`}
              >
                {/* Image with icon overlay */}
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={service.image}
                    alt={`${service.title} treatment`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-4 left-4">
                    <div
                      className="w-11 h-11 rounded-xl flex items-center justify-center shadow-sm"
                      style={{ backgroundColor: colors.bg }}
                    >
                      <Icon
                        className="w-5 h-5"
                        style={{ color: colors.color }}
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-semibold text-[#232323] mb-2">
                    {service.title}
                  </h3>
                  {service.subtitle && (
                    <p className="text-sm text-[#5E8C61] font-medium mb-3">
                      {service.subtitle}
                    </p>
                  )}
                  <p className="text-stone-500 text-sm leading-relaxed mb-5">
                    {service.descriptionEn}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-stone-100">
                    <span className="text-2xl font-bold text-[#232323]">
                      ${service.price}
                    </span>
                    <span className="text-sm text-stone-400 bg-stone-50 px-3 py-1.5 rounded-full">
                      {service.duration}
                    </span>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
